import { Level } from 'angular2-logger/core'

const vendor = 'api/jean/v1/vendor'
const vendorV2 = 'api/jean/v2/vendor'
const user = 'api/user/v2'

export const commonEnvironment = {
  debounceTime: 300,
  logger: {
    level: Level.WARN
  },
  loginUrl: '',
  signalR: {
    url: '',
    hubName: 'vendorUserHub',
    reconnectTriesCount: 3,
  },
  chat: {
    conversations: {pageSize: 20},
    messages: {pageSize: 20, typingScrollDownTolerance: 100},
    stopTyping: 5 * 1000,
    stillTyping: 30 * 1000,
    stopTypingFallback: 30 * 1000,
    unconfirmedFallback: 30 * 1000,
    charsLimit: 4000,
    charsLimitShowLast: 400,
  },
  autocomplete: {
    pageSize: 20,
  },
  api: {
    baseUrl: '',
    identityUrl: '',
    eshopUrl: 'https://m.alza.cz?jeanShop=1',
    conversations: {
      self: vendor + '/conversations',
    },
    conversationsV2: {
      self: vendorV2 + '/conversations',
    },
    user: {
      login: user + '/login',
      refreshToken: user + '/refreshToken',
    },
  },
  reports: {
    defaultThreshold: 2,
  },
  savedReplies: {
    height: 232,
    width: 500,
    dialogHeight: 350,
    dialogWidth: 250,
  },
  appOrigin: window.location.origin
}



// WEBPACK FOOTER //
// ./src/environments/common-environment.ts